import {
  Datagrid,
  TextField,
  useTranslate,
  FunctionField,
  TopToolbar,
  NumberField,
  NumberInput,
  TextInput,
  SelectInput,
  Filter,
  BulkDeleteButton,
  useNotify,
  useRefresh,
} from "react-admin";
import { JsonField } from "react-admin-json-view";
import {
  DateField,
  CustomList,
  EmptyMessage,
} from "../../shared/components/index.js";
import { ASYNC_JOB_STATUSES } from "@local/constants/index.js";

const AsyncJobFilter = (props) => {
  return (
    <Filter {...props}>
      <NumberInput source="id" alwaysOn resettable />
      <TextInput source="job_name" alwaysOn resettable />
      <SelectInput
        alwaysOn
        resettable
        source="status"
        choices={Object.keys(ASYNC_JOB_STATUSES).map((status) => ({
          id: status,
          name: `resources.AsyncJob.source.status.${status}`,
        }))}
      />
    </Filter>
  );
};

const listAsyncJobs = () => {
  const t = useTranslate();
  const notify = useNotify();
  const refresh = useRefresh();

  const onError = ({ message }) => {
    if (message.includes("plugin_inactive")) {
      return (
        notify(`resources.notifications.errors.${message}`, {
          type: "error",
          messageArgs: { resource: t("resources.AsyncJob.name") },
        }),
        refresh()
      );
    }
    return (
      notify(`resources.notifications.errors.${message}`, {
        type: "error",
      }),
      refresh()
    );
  };

  return (
    <CustomList actions={<TopToolbar />} filters={<AsyncJobFilter />}>
      <Datagrid
        empty={<EmptyMessage />}
        rowClick={false}
        bulkActionButtons={<BulkDeleteButton mutationOptions={{ onError }} />}
      >
        <NumberField source="id" />
        <TextField source="job_name" />
        <DateField source="next_run" />
        <JsonField
          source="payload"
          reactJsonOptions={{
            name: null,
            collapsed: true,
            enableClipboard: false,
            displayDataTypes: false,
          }}
          sortable={false}
        />
        <NumberField source="attempts_left" />
        <NumberField source="retry_delay" />
        <JsonField
          source="result"
          reactJsonOptions={{
            name: null,
            collapsed: true,
            enableClipboard: false,
            displayDataTypes: false,
          }}
          sortable={false}
        />
        <FunctionField
          source="status"
          render={(record) =>
            t(`resources.AsyncJob.source.status.${record.status}`)
          }
        />
        <DateField source="created_at" />
        <DateField source="updated_at" />
      </Datagrid>
    </CustomList>
  );
};

export default listAsyncJobs;
